module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container--wide"
  }, [(_vm.app.entries.length) ? _c('div', [_vm._m(0), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, _vm._l((_vm.app.entries), function(entry, index) {
    return _c('el-collapse-item', {
      key: index,
      attrs: {
        "name": index
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.generateTitle(entry))
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "responsive-table"
    }, [_c('table', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('thead', [_c('th', [_vm._v("Refuelling amount")]), _vm._v(" "), _c('th', [_vm._v("Odometer reading")]), _vm._v(" "), _c('th', [_vm._v("Price")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v(" ")])]), _vm._v(" "), _vm._l((entry.entries), function(item, itemIndex) {
      return _c('tr', {
        key: item.id
      }, [_c('td', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.refuelling_amount) + "kg\n\t\t\t\t\t\t\t\t"), (_vm.app.user.vehicle_model === 'Symbio') ? _c('span', [_vm._v("and " + _vm._s(item.electricity_amount) + "kWh")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.odometer_reading.toLocaleString()) + " " + _vm._s(_vm.app.user.units))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.app.loadCurrencySymbol(_vm.app.user.currency)) + _vm._s(item.price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.refueled_at)))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'edit-entry',
            params: {
              id: item.id
            }
          },
          "tag": "el-button"
        }
      }, [_c('i', {
        staticClass: "el-icon-edit"
      })])], 1)])
    })], 2)])], 2)
  }))], 1) : _c('div', [_c('h1', [_vm._v("You currently don't have any entries to view.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("You will be able to manage all your previous entries for the past 12 months from this page.")]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      },
      "tag": "el-button"
    }
  }, [_vm._v("\n\t\t\t\tAdd entry\n\t\t\t")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("Refuelling History "), _c('br'), _vm._v(" "), _c('small', {
    staticStyle: {
      "font-size": ".5em"
    }
  }, [_vm._v("For the past 12 months")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a9ad854","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/History.vue
// module id = 627
// module chunks = 1